import React from "react";
import { Link } from "react-router-dom";
import SocialLinks from "./SocialLinks";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>
          <strong>The Bug and Frog Foundation</strong>
          <p className="footer-tagline">Small beginnings, mighty leaps.</p>
          <SocialLinks email="info@bugandfrog.org" className="footer-social" />
        </div>
      </div>
      <div className="footer-bottom">
        © {year} The Bug and Frog Foundation. All rights reserved.
        <span className="footer-sep" aria-hidden="true"> · </span>
        <Link to="/privacy">Privacy Policy</Link>
      </div>
    </footer>
  );
}
